<template>
    <div style="background-color: rgb(251,251,251)">
        <home-header @getCity="getCity"></home-header>
<!--        <div class="wrap info_wrap">-->
<!--            <div class="info_title">{{info.title}}</div>-->
<!--            <div class="info_real" v-html="info.content"></div>-->
<!--        </div>-->
        <div class="wrap info_wrap">
            <div class="pc_news_info_cont_l">
                <div class="pc_news_info_wrap ql-editor_wrap">
                    <div class="info_title">{{ info.title }}</div>
                    <div class="pc_news_info_wrap_cont ql-editor">
                        <p v-html="info.content"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HomeHeader from "../components/blueheader";
    import lib_website from "../libs/lib_website";
    export default {
        name: "info",
        components: {
            HomeHeader
        },
        data() {
            return {
                id: 0,
                info: {},
            }
        },
        created() {
            this.id = this.$route.query.id
            lib_website.read(this.id, this.init_info)
            console.log(this.$route, '===')
        },
        methods: {
            getCity(city) {

            },
            init_info(data) {
                this.info = data
                console.log(data, '数据')
            }
        }
    }
</script>

<style scoped lang="less">



    @import "../assets/style/info.less";
    @import "../assets/style/editor.less";
    .info_wrap{
        width: 100%;
        margin-top: 40px;
        background: #fff;
        border: solid 1px #e1e1e1;
        box-shadow: 0px 0px 10px 2px #ccc;
        border-radius: 10px;
        min-height: 200px;
        padding: 2%;
        box-sizing: border-box;
    }
    .info_title{
        text-align: center!important;
        margin: 20px 0px!important;
        font-size: 22px!important;
        font-weight: bold!important;
        color: #333!important;
    }
</style>
